import React from 'react';

import './game-footer.styles.css';

const GameFooter = () => {

    return (
        <div className="game-footer-text">Train Your Brain Everyday!</div>
    )
}

export default GameFooter;